import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.me/2673928692" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-green-500 text-white rounded-full shadow-lg hover:scale-110 transition-transform duration-300 group" aria-label="Chat on WhatsApp" data-id="element-123">
      <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20" data-id="element-124"></div>
      <MessageCircleIcon className="w-7 h-7 relative z-10" data-id="element-125" />

      {/* Tooltip */}
      <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-brand-charcoal text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap border border-white/10" data-id="element-126">
        Chat with us
      </span>
    </a>;
}